import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { UpdateLifetimeAllowanceStatic } from "./UpdateLifetimeAllowanceStatic";
import { AccountLifetimeAllowanceStatic } from "./AccountLifetimeAllowanceStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const UpdateLifetimeAllowanceDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const UpdateLifetimeAllowanceStore: UpdateLifetimeAllowanceStatic = new UpdateLifetimeAllowanceStatic();


export const AccountLifetimeAllowanceDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AccountLifetimeAllowanceStore: AccountLifetimeAllowanceStatic = new AccountLifetimeAllowanceStatic();
